import { Injectable } from '@angular/core';
import { IFrameRequestHandlerI } from '@shared/services/integrations/iframe-request-handler.interface';
import { IFrameContactRequest, IFrameMethod } from '@intheloop/loop-integration';
import { Observable } from 'rxjs';
import { SmartContactsApiService } from '@shared/modules/contacts/shell/contacts-api-cache/smart-contacts-api.service';

@Injectable()
export class ContactHelper implements IFrameRequestHandlerI {
  constructor(private smartContactsApiService: SmartContactsApiService) {}

  handleRequest(request: IFrameContactRequest, integrationId: string): Observable<any> {
    switch (request.method) {
      case IFrameMethod.GET_CONTACT:
        return this.smartContactsApiService.getSingle(request.contactId);
    }
  }
}
